import { EstimateSplitFulfillmentStatus } from "../../../views/Orders/enums";

export function resolveDefaultFulfillmentStatusForSupplier(
  supplierId: string | null | undefined,
  confirmationNeededSupplierId?: string | null,
  additionalTimeRequiredSupplierId?: string | null,
): EstimateSplitFulfillmentStatus | undefined {
  if (supplierId == null || supplierId === "") {
    return undefined;
  }
  const id = String(supplierId);
  const confirmationId = String(confirmationNeededSupplierId ?? "").trim();
  const timeRequiredId = String(
    additionalTimeRequiredSupplierId ?? "",
  ).trim();

  if (confirmationId && id === confirmationId) {
    return EstimateSplitFulfillmentStatus.CONFIRMATION_NEEDED;
  }
  if (timeRequiredId && id === timeRequiredId) {
    return EstimateSplitFulfillmentStatus.NOT_AVAILABLE;
  }
  return EstimateSplitFulfillmentStatus.FULFILLED;
}
